/**
 * Absolute URL for the Phase 2 platform-admin SPA.
 * When unset, interim `/admin` routes on the landlord SPA remain active.
 */
export function getAdminAppBaseUrl(): string | null {
  const raw = (process.env.REACT_APP_ADMIN_URL || '').trim().replace(/\/$/, '');
  return raw || null;
}

/** Map landlord-app `/admin/...` path onto the admin SPA host path. */
export function mapAdminPathToAdminSpa(pathname: string): string {
  if (!pathname.startsWith('/admin')) return '/';
  const rest = pathname.slice('/admin'.length) || '/';
  return rest.startsWith('/') ? rest : `/${rest}`;
}

/**
 * Soft-redirect browser to the admin SPA when REACT_APP_ADMIN_URL is set.
 * Returns true if a redirect was initiated.
 */
export function redirectToAdminSpa(pathname?: string): boolean {
  const base = getAdminAppBaseUrl();
  if (!base || typeof window === 'undefined') return false;
  const path = mapAdminPathToAdminSpa(pathname || window.location.pathname || '/');
  const target = `${base}${path === '/' ? '' : path}${window.location.search || ''}`;
  window.location.replace(target);
  return true;
}
